export const FirebaseConfig = {
	"projectId": "los-tolues-8e595",
	"appId": "1:12169095004:web:ec48eb17d144be6fe90399",
	"databaseURL": "https://los-tolues-8e595-default-rtdb.firebaseio.com",
	"storageBucket": "los-tolues-8e595.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyCte9Q64v_FFTPRRnbaFFJZ7mGvyEIcTIQ",
	"authDomain": "los-tolues-8e595.firebaseapp.com",
	"messagingSenderId": "12169095004"
};